import React, { useEffect, useState } from "react";
import axios from "axios";
import Url from "../../util/url";
import InfoUser from "./TemplateInfoUser";
import { useDispatch, connect } from "react-redux";

const Profile = ({ myProfile }) => {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const currentId = userInfo._id;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: "SET_PAGE", data: "" });
    }, []);

    useEffect(() => {
        getUserInfo();
    }, []);

    const getUserInfo = async () => {
        dispatch({ type: "SET_USER_INFO", data: [] });
        const res = await axios.get(Url("user/info/" + currentId));
        if (res.data.success) {
            dispatch({ type: "SET_USER_INFO", data: res.data.response[0] });
        }
    };

    return (
        <div style={{ maxWidth: 600, margin: "24px auto", padding: "0 16px" }}>
            <InfoUser myProfile={myProfile} showDetail={false} />
        </div>
    );
};

function mapStateToProps(state) {
    return {
        myProfile: state.myProfile.userInfo,
    };
}

export default connect(mapStateToProps, {})(Profile);
